export const UPDATE_NUMERO_ASSEGNO_1 	                = 'UPDATE_NUMERO_ASSEGNO_1';
export const UPDATE_NUMERO_ASSEGNO_2 	                = 'UPDATE_NUMERO_ASSEGNO_2';
export const UPDATE_BANCA_1 		 	                = 'UPDATE_BANCA_1';
export const UPDATE_BANCA_2 		 	                = 'UPDATE_BANCA_2';
export const UPDATE_AGENZIA_1 		 	                = 'UPDATE_AGENZIA_1';
export const UPDATE_AGENZIA_2 		 	                = 'UPDATE_AGENZIA_2';
export const UPDATE_COINTESTATO                         = 'UPDATE_COINTESTATO';
export const UPDATE_NOME_COGNOME_COINTESTATARIO         = 'UPDATE_NOME_COGNOME_COINTESTATARIO';
export const UPDATE_RELAZ_PAGAT_CONTR                   = 'UPDATE_RELAZ_PAGAT_CONTR';
export const UPDATE_ALTRA_RELAZ                         = 'UPDATE_ALTRA_RELAZ';